// Links remain usable without JavaScript; supporting browsers open a scrollable full-size view.
document.addEventListener('DOMContentLoaded', () => {
    const dialog = document.querySelector('.moto-guide-lightbox');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    const image = dialog.querySelector('img');
    const caption = dialog.querySelector('figcaption');

    document.querySelectorAll('[data-guide-image]').forEach(link => {
        link.setAttribute('aria-haspopup', 'dialog');
        link.addEventListener('click', event => {
            if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            image.src = link.href;
            image.alt = link.querySelector('img').alt;
            caption.textContent = link.closest('figure').querySelector('figcaption').innerText;
            dialog.showModal();
            dialog.scrollTop = 0;
            document.body.classList.add('moto-guide-image-open');
        });
    });
    dialog.querySelector('[data-guide-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
        if (event.target === dialog) {
            const bounds = dialog.getBoundingClientRect();
            if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
        }
    });
    dialog.addEventListener('close', () => {
        document.body.classList.remove('moto-guide-image-open');
        image.removeAttribute('src');
    });
});
